import { render, staticRenderFns } from "./AddComponentWizardDialog.vue?vue&type=template&id=5150a585&"
import script from "./AddComponentWizardDialog.vue?vue&type=script&lang=js&"
export * from "./AddComponentWizardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports